import { LEARNER_ASSIGNMENT_QUERY_KEY } from "./learnerAssignmentQueryKeys";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ILearnerAssignment } from "../types";

export type ILearnerAssignmentQueryParameters = {
    assignment?: RelationalValue<ILearnerAssignment>;
};

export type ILearnerAssignmentQueryResult = ILearnerAssignment;

export const learnerAssignmentQuery: IApiQueryFunction<ILearnerAssignmentQueryParameters> = ({ assignment }) => {
    if (!assignment) {
        return;
    }

    return {
        method: "GET",
        url: `/learner_assignments/${mapRelationalValue(assignment)}`,
    };
};

const useQuery = createApiQueryHook<ILearnerAssignmentQueryParameters, ILearnerAssignmentQueryResult>(
    learnerAssignmentQuery,
);

export const useLearnerAssignmentQuery = (
    parameters: ILearnerAssignmentQueryParameters,
    options: Omit<NonNullable<Parameters<typeof useQuery>[1]>, "queryKey"> = {},
) => useQuery(parameters, { ...options, queryKey: [LEARNER_ASSIGNMENT_QUERY_KEY, "item", parameters] });
